import React, { useEffect, useState } from 'react';
import { MenuDropdownWrapper, MenuWrapper } from './Menu.style';
import { isFunction } from 'lodash';

interface MenuProps {
  label: React.ReactNode;
  menuDropdown: React.ReactNode;
  onToggleMenuDropdown?: (isVisible: boolean) => void;
}

const Menu: React.FC<MenuProps> = ({
  label,
  menuDropdown,
  onToggleMenuDropdown,
}) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    if (isFunction(onToggleMenuDropdown))
      onToggleMenuDropdown(isDropdownVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDropdownVisible]);

  return (
    <MenuWrapper
      onMouseOver={() => setDropdownVisible(true)}
      onMouseLeave={() => setDropdownVisible(false)}
    >
      {label}
      <MenuDropdownWrapper isShow={isDropdownVisible}>
        {menuDropdown}
      </MenuDropdownWrapper>
    </MenuWrapper>
  );
};

export default Menu;
